import project from "./project";
import admin from "./admin";
import users from "./users";
import errorcodes from "./errorcodes";
import events from "./masters/events";
import blogCategories from "./blogs/categories";
import blogs from "./blogs/blogs";
import dns from "./dnsRecord";
import controlCenter from "./controlCenter";
import brandProfile from "./brandProfile";

import author from "./eLearning/author";
import category from "./eLearning/category";
import course from "./eLearning/course";
import chapter from "./eLearning/chapter";
import topic from "./eLearning/topic";

import portfolioTestimonial from "./portfolio/testimonial";
import portfolioCategory from "./portfolio/category";
import portfolioSubcategory from "./portfolio/subcategory";
import menu from "./menu";
import websiteRole from "./WebsiteRole/websiteRole";

const repositories = {
  project: project,
  admin,
  users,
  errorcodes,
  brandProfile,
  events,
  blogCategories,
  blogs,
  dns,
  controlCenter,
  author,
  category,
  course,
  chapter,
  topic,
  portfolioTestimonial,
  portfolioCategory,
  portfolioSubcategory,
  menu,
  websiteRole,
};

export const RepositoryFactory = {
  get: (name) => repositories[name],
};
